<template>
  <div class="account-info-component">
    <template>
      <div class="user_details">
        <div class="user_image">
          <span class="pd-icon pd-icon-player-icon"></span>
        </div>
        <span class="user_title">{{ personalDetails && personalDetails.FirstName }} {{ personalDetails && personalDetails.LastName && personalDetails.LastName[0] }}.</span>
        <div class="session_details">
          <div class="lastlogin">Last logged in: <span>{{ lastLogin || '--' }}</span></div>

          <div>Session duration: <span>{{sessionTime}}</span></div>
        </div>
      </div>
      <div class="account_balance">
        <v-layout v-if="showBalance" justify-center>
          <v-flex xs6 class="balance">
            <span class="text"> {{ $t('MyAccount.CurrentBalance') }} </span>
            <span class="value" @click="getWalletBalance()">{{ totalCacheBalance | currency }}</span>
          </v-flex>
          <v-flex xs6 class="bonus">
            <span class="text">{{ $t('MyAccount.SportsbookBonus') }}</span>
            <span class="value" @click="getWalletBalance()">{{ siteCreditBalance | currency }}</span>
          </v-flex>
          <span class="show_hide_text" v-if="showBalance" flat @click.stop="toggleShowBalance(showBalance)">
              {{ showBalance ? 'Hide' : 'Show' }}
          </span>
        </v-layout>
        <div v-if="!showBalance" class="show_hide" @click.stop="toggleShowBalance(showBalance)">
          <span>
            {{ showBalance ? 'Hide' : 'Show' }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'
  import Icon from '@/components/common/Icon'
  import Screen from '@/components/mixins/Screen'
  import Time from '@/components/mixins/Time'

  export default {
    name: 'AccountInfoComponent',

    mixins: [
      Screen,
      Time
    ],

    data () {
      return {
        showBalance: true,
        sessionTime: 0
      }
    },

    components: {
      Icon
    },

    computed: {
      dateFormats () { return config.app.dateFormats },
      accountDetails () {
        return store.getters['getAccountDetails']
      },
      personalDetails () {
        return store.getters['getPersonalDetails']
      },
      creditAccountDetails () {
        return this.accountDetails.filter(item => item.IDMMAccountClass === 'CREDIT')[0]
      },
      walletBalances () {
        return store.getters['getWalletBalance']
      },
      siteCreditBalance () {
        let balance = this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.filter(balance => balance.type === 'AVAILABLE_BONUS')
        return (balance && balance[0] && balance[0].amount) || 0
      },
      totalCacheBalance () {
        let balance = this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.filter(balance => balance.type === 'RM')
        return (balance && balance[0] && balance[0].amount) || 0
      },
      sessionDetails () {
        return store.getters['getSessionDetails']
      },
      igtcLastLoginDetails () {
        return store.getters['getIgtcLastLoginDetails']
      },
      lastLogin () {
        if (config.app.autoconf.EXTERNAL_WALLET_PROVIDER === 'IGTC') {
          var igtcLastLoginDate = this.igtcLastLoginDetails && this.igtcLastLoginDetails.loginDate

          if (igtcLastLoginDate) {
            return (igtcLastLoginDate && this.dateToLocaleDatetimeString(new Date(igtcLastLoginDate), this.dateFormats.longDateTime))
          } else {
            return 0
          }
        } else {
          var sessionDetails = config.customCookies.getCookie('sessionDetails')
          var lastLoginDate = (this.sessionDetails && (this.sessionDetails.lastlogin || this.sessionDetails.lastLoginDate)) ||
            (sessionDetails && (sessionDetails.lastlogin || sessionDetails.lastLoginDate))

          return (lastLoginDate && this.dateToLocaleDatetimeString(new Date(lastLoginDate), this.dateFormats.longDateTime)
          )
        }
      }
    },

    methods: {
      toggleShowBalance (value) {
        this.showBalance = !this.showBalance
        if (value) {
          store.commit('setShowBalance', false)
        } else if (!value) {
          store.commit('setShowBalance', true)
        }
      },
      closeMyAccountDialog () {
        store.dispatch('overlayState/deactivateMyAccountDialog')
      },
      getWalletBalance () {
        store.dispatch('getWalletBalance')
      }
    },

    created () {
      setInterval(() => {
        let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
        if (value >= 0) {
          let minutes = Math.floor(value / 60)
          let seconds = value - minutes * 60
          seconds = (seconds < 10 ? ('0' + seconds) : seconds)
          minutes = (minutes < 10 ? ('0' + minutes) : minutes)
          this.sessionTime = `${minutes}:${seconds}`
        }
      }, 1000)
    }

  }
</script>

<style lang="stylus" scoped>
  @import '~@/css/config'

  .navigation-drawer
    .account-info-component
      >>>.back_icon
          display none
  .account-info-component
    width: 100%

    .lastlogin
      font-size: 10px
      opacity: 0.8

      .dialog-menu &
        display: none

      @media tablet-and-above
        display: none

    .show_hide
      display: flex
      align-items: center
      justify-content: center
      color: #0090FF
      cursor: pointer

      span
        font-size: 14px !important
        font-weight: bold

    .btn--icon
      width: auto
      margin: 0 8px 0 0

      .icon
        font-size: 20px
        color: #0090FF

    .user_title
      font-size: 16px
      line-height: 19px
      display: block

    .user_title_first
      font-size: 16px
      line-height: 19px
      display: block

      .dialog-menu &
        display: block

      @media mobile-big-and-below
        display: none

    .account_balance
      margin-top: 10px
      min-height: 45px

      .dialog-menu &
        display: none

      @media mobile-big-and-below
        min-height: 55px

      span
        display: block
        font-size: 12px
        text-transform: uppercase
        opacity: 0.8

        @media mobile-big-and-below
          font-size: 10px

      .bonus
        margin-left: 4px
        position: relative

        button
          position: absolute
          top: -4px
          right: 0

      .value
        font-size: 18px
        font-weight: bold
        line-height:16px
        opacity: 1

        @media mobile-big-and-below
          font-size: 30px
          line-height: 30px

  .back_icon
    float: right

  .user_details
    display: inline-block
</style>



// WEBPACK FOOTER //
// src/components/horses/account/AccountInfoComponent.vue